/**
 * Matches the cached queries of the given names that read one collection, by the `collection_id` in their variables,
 * so a change to the collection can invalidate them together.
 */
export function collectionQueryPredicate(names: readonly string[], collectionId: string) {
  return ({ queryKey: [name, variables] }: { queryKey: readonly unknown[] }) =>
    names.includes(name as string) &&
    (variables as { collection_id?: string } | undefined)?.collection_id === collectionId;
}
